import { render } from "./ScreenGreenAnswer.vue?vue&type=template&id=f791ffbc&scoped=true&ts=true"
import script from "./ScreenGreenAnswer.vue?vue&type=script&lang=ts"
export * from "./ScreenGreenAnswer.vue?vue&type=script&lang=ts"

import "./ScreenGreenAnswer.vue?vue&type=style&index=0&id=f791ffbc&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f791ffbc"]])

export default __exports__